import { Store } from '@app/shared/modules/mobile-badge/enums/store.enum';

export const STORES: { [store in Store]: { ru: string; global: string } } = {
  [Store.AppStore]: {
    ru: 'app-store-ru.svg',
    global: 'app-store-en.svg',
  },
  [Store.GooglePlay]: {
    ru: 'google-play-ru.svg',
    global: 'google-play-en.svg',
  },
  [Store.AppGallery]: {
    ru: 'app-gallery-ru.svg',
    global: 'app-gallery-en.svg',
  },
  [Store.GalaxyStore]: {
    ru: 'galaxy-store-ru.svg',
    global: 'galaxy-store-en.svg',
  },
  [Store.GetApps]: {
    ru: 'get-apps-ru.svg',
    global: 'get-apps-en.svg',
  },
  [Store.Apk]: {
    ru: 'apk-en.svg',
    global: 'apk-en.svg',
  },
  [Store.RuStore]: {
    ru: 'rustore-ru.svg',
    global: 'rustore-en.svg',
  },
};
